import {event} from '../modules/event';
import {ajax} from '../modules/ajax';
import {page} from "./page";

export default class {
    constructor(wrapper) {
        this._createElements(wrapper);
        this._getBtn();
        this._defineAjaxPath();
        this._addEvent();
        this._addToGlobal();
    }

    _createElements(wrapper){
        var self = this;
        this.wrapper = wrapper;
        this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
        this.btn;
        this.isFav = this.wrapper.className.indexOf('js-fav') === -1 ? false : true;
        this.isSending = false;
        this.onchange = function(){};
    }

    _getBtn(){
        if(this.wrapper.getAttribute('data-js') === 'fav-btn') this.btn = this.wrapper;
        else this.btn = this.wrapper.querySelector('[data-js="fav-btn"]');
    }

    /*_defineAjaxPath(){
        var part = (window.location + '').indexOf('/_src/') === -1 ? '' : '/_src/layouts';
        this.ajaxPath = part + '/' + this.data.type + '/' + this.data.uid + '/fav/';
    }*/


    _defineAjaxPath(){
        var self = this;
        self.data = JSON.parse(self.wrapper.getAttribute('data-param'));
        var part = APP.vars.isDev ? '/_src/layouts' : '',
            part2 =  '/' + self.data.type + '/' + self.data.uid + '/fav/';
        self.ajaxPath = part + part2;
    }

    _addEvent(){
        var self = this;
        event.add(this.btn, 'click', function(e){
            e.preventDefault();
            e.stopPropagation();

            self._defineAjaxPath();
            self._addToGlobal();

            if(!self._checkAuth.call(self)) return false;

            if(self.isSending) return false;
            self.isSending = true;

            ajax({
                data:{"fav":!self.isFav},
                url:self.ajaxPath,
                callback: function(msg){
                    self._checkMsg.call(self, msg);
                }
            });
        });
    }

    _checkAuth(){
        if (APP.vars.isMobile) {
            if (!('isUserAuth' in window) || !(window.isUserAuth)){
                var $popup = $('#favoriteStartPopup');
                $popup.show();
                APP.touchDisable();
                return false;
            }
        } else if (!regAuthObj.isAuth) {
            this._showFavPopup();
            return false;
        }
        return true;
    }

    _showFavPopup(){
        page('howFav');

        /*uPopup.closeAll();
        uPopup({
            addClass:'popup-middle',
            name:'howFav',
            content: document.getElementById('howFavPopup')
        });*/
    }

    _checkMsg(msg){
        var msg = JSON.parse(msg);

        if (msg.auth === false){
            uPopup({
                content: 'Вам нужно авторизоваться повторно.',
                oncloseBefore: function () {
                    location.replace(location.protocol + '//' + location.host + location.pathname);
                }
            });
        }
        else if(!msg.status){
            uPopup({
                content: msg.message
            });
        }
        else {
            if(msg.data){
                this.addToFav();
                this._sendStat();
            }
            else {
                this._removeFromFav();
            }
        }

        this.isSending = false;
    }

    _sendStat(){
        if ( this.data.type ){
            try{
                gtag('event', 'click', {
                    'event_category': 'favourite',
                    'event_label': 'add_' + this.data.type + '_to_favourite'
                });
            }catch(e){

            }
        } else {
            console.error('gtag unknown type');
        }
    }

    addToFav(){
        /*
        Добавляем в избранное (фильм, кинотеатр итд) сразу ко всем одинаковым id
		 Ф-я может вызываться из глобального объекта - если мы щелкнули на пойду у фильма - то автоматом добаляется избранное
        */
        var key = 'uid-' + this.data.uid,
            type = this.data.type,
            all = window.GLOBALS[type+'FavAll'][key];

        for(var i= 0,j=all.length; i<j; i++){
            all[i].wrapper.className = all[i].wrapper.className.replace(/\s*js-fav/, '') + ' js-fav';
            all[i].isFav = true;
        }
        this.onchange(true);

        this._addCustomEvent({isFav:true, typeFav:type, uid:this.data.uid});
    }

    _removeFromFav(){
        var key = 'uid-' + this.data.uid,
            type = this.data.type,
            all = window.GLOBALS[type+'FavAll'][key];

        for(var i= 0,j=all.length; i<j; i++){
            all[i].wrapper.className = all[i].wrapper.className.replace(/\s*js-fav/, '');
            all[i].isFav = false;
        }
        this.onchange(false);

        this._addCustomEvent({isFav:false, typeFav:type, uid:this.data.uid});
    }

    _addCustomEvent(data){
        if(window.CustomEvent) {
            var event = new Event(data.typeFav + 'ChangeFav');
            event.isFav = data.isFav;
            event.uid = data.uid;
            document.dispatchEvent(event);
        }
    }

    _addToGlobal (){
        var key = 'uid-' + this.data.uid;
        var type = this.data.type;

        if(!window.GLOBALS) window.GLOBALS = {};
        if(!window.GLOBALS[type+'FavAll']) window.GLOBALS[type+'FavAll'] = {};
        if(!window.GLOBALS[type+'FavAll'][key]) window.GLOBALS[type+'FavAll'][key] = [];

        window.GLOBALS[type+'FavAll'][key].push(this);
    }

    isDOM(){
        if(this.wrapper.getClientRects().length) return true;
        else return false;
    }

    del(){
        var key = 'uid-' + this.data.uid;
        var type = this.data.type;
        var all = window.GLOBALS[type+'FavAll'][key];

        for(var i= 0,j=all.length; i<j; i++){
            if(all[i] === this) {
                all.splice(i, 1);
                if(!all.length) delete window.GLOBALS[type+'FavAll'][key];
                return false;
            }
        }
    }
}